const { transformNodeText } = require('../helpers/analytics');

module.exports = (node, option) => {
  if (!(option === 'header' || option === 'footer')) { throw "Invalid option" }
  return `splash.${option}.${transformNodeText(node.text)}.click`;
};




// WEBPACK FOOTER //
// ./src/pages/helpers/getHeaderFooterClickEventName.js